import React from 'react';
import agent from '../../agent';

class PostImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: '',
        }
    }
    componentWillMount() {
        const that = this

        if (this.props.imageId) {
            agent.Posts.getPostImage(this.props.imageId).then(res=>{
                var reader = new window.FileReader();
                reader.readAsDataURL(res.xhr.response);
                reader.onloadend = () => {
                    that.setState({
                        image: reader.result,
                    })
                }

            })
        }
    }
    render() {
        return (
            <img src={this.state.image} alt={this.props.imageId} className="card-img-bottom url-preview-img border-radius-10" />
        );
    }
}

export default PostImage;
